import { MutationCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getApiErrorMessage } from "@/lib/api-error";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (error) => {
      // Toast global para qualquer mutation que falhe. Páginas mantêm controle
      // sobre toast de sucesso (mais específico por contexto).
      toast.error(getApiErrorMessage(error, "Falha ao executar a ação."));
    },
  }),
});
